import trackEvent from '@/common/js/track'

/**
 * dgd页面按钮点击
 * @param {*} attrs 
 * country 国家编码,MX BR JP
 * city_id 城市id
 * rider_id 骑手id
 * reward_id 活动id
 * click_type 1 邀请，2 其他，3 左上角返回
 */
export function dgdButtonClick (attrs = {
  country: 'MX',
  city_id: 0,
  rider_id: 0,
  reward_id: 0,
  click_type: 0
}) {
  trackEvent({ 
    eventId: 'sailing_d_x_dgd_invite_ck',
    eventLabel: 'dgd页面按钮点击',
    attrs
  })
}

/**
 * dgd页面按钮点击
 * @param {*} attrs 
 * country 国家编码,MX BR JP
 * city_id 城市id
 * rider_id 骑手id
 * reward_id 活动id
 * click_type 1 facebook，2 twitter，3 其他，4 左上角关闭按钮，5 下方邀请码copy
 */
export function dgdInviteOtherPopup (attrs = {
  country: 'MX',
  city_id: 0,
  rider_id: 0,
  reward_id: 0,
  click_type: 0
}) {
  trackEvent({ 
    eventId: 'sailing_d_x_dgd_invite_other_popup_ck',
    eventLabel: 'dgd页面点击other后谈层页面按钮点击',
    attrs
  })
}
